<template>
    <j-modal :title="title" width="40%" :visible="visible" :confirmLoading="confirmLoading"
      :maskClosable="false" :body-style="{ height: '380px', overflow: 'hidden', overflowY: 'scroll' }" @ok="handleOk"
      @cancel="handleCancel" :okText="$t('确定')" :cancelText="$t('关闭')" :okButtonProps="{ class:{'jee-hidden': disableSubmit} }">
      <a-spin :spinning="confirmLoading">
        <j-form-container :disabled="disableSubmit">
          <a-form-model ref="form" :model="model" :rules="validatorRules" slot="detail" :colon="false">
            <a-row :gutter="24">
              <a-col :span="24">
                <a-form-model-item :label="$t('项目代码')" prop="projectCode">
                  <a-input v-model="model.projectCode" :placeholder="$t('请输入项目代码')" disabled></a-input>
                </a-form-model-item>
              </a-col>
              <a-col :span="24">
                <a-form-model-item :label="$t('拓扑名称')" prop="name">
                  <a-input v-model="model.name" :placeholder="$t('请输入拓扑名称')"></a-input>
                </a-form-model-item>
              </a-col>
              <a-col :span="24">
                <a-form-model-item :label="$t('备注')" prop="remark">
                  <a-textarea v-model="model.remark" :placeholder="$t('请输入备注')" row-span="2" />
                </a-form-model-item>
              </a-col>
            </a-row>
          </a-form-model>
        </j-form-container>
      </a-spin>
    </j-modal>
  </template>
  
  <script>
    import {
      httpAction,
      getAction,
      postAction
    } from '@/api/manage'
    import {
      validateDuplicateValue
    } from '@/utils/util'
    export default {
      name: 'modal',
      components: {},
      data() {
        return {
          title: this.$t('新增拓扑'),
          width: 800,
          visible: false,
          disableSubmit: false,
          confirmLoading: false,
          model: {},
          url: {
            createTopology: "/jeecg-gis/topology/topology/createTopology",
            updateTopology: "/jeecg-gis/topology/topology/updateTopology",
          },
        }
      },
      computed: {
        validatorRules() {
          return {
            name: [{required:true,message:this.$t('请输入拓扑名称')}],
            projectCode: [{required:true,message:this.$t('请输入拓扑代码')}],
            remark: [{required:true,message:this.$t('请输入备注')}],
          }
        },
      },
      methods: {
        init(row){
          this.visible = true;
          if(row.type){
            this.model = JSON.parse(JSON.stringify(row));
          }else{
            this.model = {
              projectCode: row.code,
            }
          }
        },
        close() {
          this.$emit('close');
          this.visible = false;
        },
        handleCancel() {
          this.close()
        },
        handleOk(){
          const that = this;
          this.$refs.form.validate(valid => {
            if(valid){
              that.confirmLoading = true;
              let url = '';
              let message = '';
              if(this.model.id){
                url = this.url.updateTopology;
                message = this.$t('编辑成功！')
              }else{
                url = this.url.createTopology;
                message = this.$t('新增成功！')
              }
              postAction(url, this.model).then((res) => {
                if (res.success) {
                  that.$message.success(message);
                  that.$emit('ok');
                  this.visible = false;
                } else {
                  that.$message.warning(res.message);
                }
              }).finally(() => {
                that.confirmLoading = false;
              })
            }
          })
        }
      }
    }
  </script>